import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import * as THREE from 'three';
import {Box3} from "three";

export function textCard(
    text: string,
    fontSize: number,
    bevelSize: number,
    callback: (mesh: THREE.Mesh) => void,
): void {
    const loader = new FontLoader();

    loader.load(
        // URL du fichier de police
        'assets/three/FONT/Proxima_Nova_Regular.json',

        (font: any): void => {
            const textGeometry = new TextGeometry(text, {
                font: font,
                size: fontSize,
                depth: 0.00001,
                curveSegments: 64,
                bevelEnabled: true,
                bevelThickness: 0.01,
                bevelSize: bevelSize,
                bevelSegments: 5,
            });

            textGeometry.computeBoundingBox();
            const bbox: Box3 = textGeometry.boundingBox!;
            const textWidth: number = bbox.max.x - bbox.min.x;
            const textHeight: number = bbox.max.y - bbox.min.y;

            const textMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
            const textMesh = new THREE.Mesh(textGeometry, textMaterial);

            textMesh.position.set(-textWidth / 2, -textHeight / 2, 0.01);

            callback(textMesh);
        },

        (xhr: ProgressEvent): void => {
            if (xhr.total > 0) {
                // console.log((xhr.loaded / xhr.total) * 100 + '% font loaded');
            }
        },

        (err: unknown): void => {
            console.error('An error occurred:', err);
        }
    );
}
